import React from 'react'
import styles from "./markupLayout.module.css"
export function MarkupLayout({ children }) {
  return (
    <div className={styles.container}>{children}</div>
  )
}
